// LM(anahtar, yedek): cevrilen metni window.LM_T'den okur, yoksa yedege duser.
function LM(a, yedek) {
  var t = (typeof window !== 'undefined' && window.LM_T) || {};
  return t[a] || yedek;
}
import { formatMoney } from '@theme/money-formatting';
import { tasarrufHesapla, tasarrufMetni, setTeklifi, teklifUygunMu, anaAdet, gerekenAnaAdet } from '@theme/lm-tasarruf';

/**
 * Seri Kutucuk — satin alma kutusundaki kompakt set secici.
 *
 * Secilen parcalar musteri temanin kendi "Sepete ekle" dugmesine bastiginda,
 * ana urunun eklenmesi TAMAMLANDIKTAN sonra ayni sepete eklenir. Bunun icin
 * temanin yayinladigi cart olayi dinlenir (cart-drawer da ayni olayi dinliyor);
 * olay modulu yuklenemezse dugmeye tiklamayi dogrudan dinleyen yedek yol devreye
 * girer, yani secim sessizce kaybolmaz.
 */
class SeriKutucuk extends HTMLElement {
  // Secili kisi sayisi. Set tek varyanta indiyse (18.10.2026: yalniz 4 kisilik)
  // tema variant-picker'a girdi basmaz; o zaman tek set varyantinin anahtari alinir.
  #kisi() {
    const s = document.querySelector('variant-picker input:checked, variant-picker select');
    const t = (s?.value || '').match(/\d+/);
    if (t) return t[0];
    try {
      const anahtar = Object.keys(JSON.parse(this.dataset.setVaryant || '{}'));
      return anahtar.length === 1 ? anahtar[0] : null;
    } catch { return null; }   // sessiz: bozuk data-set-varyant = secim yok, kutu liste fiyatina duser
  }

  #eklemeSuruyor = false;
  #notVarsayilan = '';
  #ilkFiyat = null;
  #anaAdetBiz = false;   // ana urun adedini TEKLIF mi degistirdi
  #adetYaziyor = false;  // adedi SU AN biz mi yaziyoruz (kendi olayimizi dinlemeyelim)


  /**
   * Sunum Seti sayfasi: "Kisi Sayisi" varyanti degisince kutudaki adetler
   * o varyantin sabit bilesimine ayarlanir (1 runner + N servis + N altlik + 2 kirlent).
   * Musteri sonra adetleri serbestce degistirebilir; degistirdigi an kendi seti olur.
   */
  #setBilesimKur() {
    if (this.dataset.setSayfasi !== '1') return;
    // Temanin kendi "Sepete ekle"si set varyantini ekler, kutu da parcalari ekler:
    // ikisi birden = cift fatura. Gizlemeyi JS yapar; JS yuklenmezse tema dugmesi
    // gorunur kalir ve dogru fiyatli set varyantini ekler (guvenli geri dusus).
    document.documentElement.classList.add('seri-set-hazir');
    let bilesim;
    try { bilesim = JSON.parse(this.dataset.setBilesim || '{}'); } catch (e) { return; }

    const uygula = (kisi) => {
      const i = bilesim[String(kisi)];
      if (!i) return;
      const gorulen = new Set();
      this.girisler.forEach((g) => {
        const oge = g.closest('.seri-kutucuk__oge');
        const parca = g.dataset.parca;
        // ayni parca iki satirda gorunuyorsa (or. kombin urunu) ikincisi set
        // bilesimine dahil edilmez; yoksa ayni parca iki kez faturalanir.
        if (gorulen.has(parca)) { g.checked = false; return; }
        gorulen.add(parca);
        const sayi = oge?.querySelector('.seri-kutucuk__sayi');
        if (!sayi) return;
        // altlik: tekli varyant kisi sayisi kadar, 4'lu set kutusu bos kalir
        const adet = parca === 'altlik' ? i.altlik : (i[parca] || 0);
        if (adet > 0) { g.checked = true; sayi.value = String(adet); }
        else { g.checked = false; sayi.value = '1'; }
      });
      this.#tazele();
    };

    const kisiOku = () => this.#kisi();
    const ilk = kisiOku();
    if (ilk) uygula(ilk);
    document.addEventListener('change', (olay) => {
      if (!olay.target.closest('variant-picker')) return;
      this.#ilkFiyat = null;   // fiyati tema yeniden yazar, onbellek bayatlar
      const k = kisiOku();
      if (k) uygula(k);
    });
  }

  async connectedCallback() {
    this.girisler = [...this.querySelectorAll('.seri-kutucuk__giris')];
    this.tetik = this.querySelector('[data-ref="tetik"]');
    this.panel = this.querySelector('[data-ref="panel"]');
    this.ozetEl = this.querySelector('[data-ref="ozet"]');
    this.ekleEl = this.querySelector('[data-ref="ekle"]');
    this.ekleMetinEl = this.querySelector('[data-ref="ekleMetin"]');
    this.ekleMetin = this.ekleMetinEl?.textContent?.trim() || LM('setEkle', 'Seçilenleri sepete ekle');
    this.notEl = this.querySelector('[data-ref="not"]');

    this.bosMetin = this.dataset.bos || LM('setBos', 'Aynı seriden parça ekle');
    this.seciliMetin =
      this.dataset.setSayfasi === '1'
        ? LM('setOzetSet', '[n] parça · set tutarı [tutar]')
        : this.dataset.secili || LM('setOzetSecili', '[n] parça seçildi · +[tutar]');
    this.#notVarsayilan = this.notEl?.textContent?.trim() || '';
    this.paraBicimi = this.dataset.moneyFormat || '{{amount_with_comma_separator}} TL';
    this.parabirimi = this.dataset.currency || 'TRY';

    this.tetik?.addEventListener('click', () => this.#ac());
    this.girisler.forEach((g) => g.addEventListener('change', () => this.#tazele()));
    // adet secici etiketin icinde: tiklama kutucugu acip kapatmasin
    this.addEventListener('mousedown', (olay) => {
      if (olay.target.closest('.seri-kutucuk__yon, .seri-kutucuk__sayi')) olay.preventDefault();
    });
    this.addEventListener('click', (olay) => {
      const teklif = olay.target.closest('.seri-kutucuk__teklif');
      if (teklif) {
        olay.preventDefault();
        olay.stopPropagation();
        this.#teklifUygula(teklif.dataset.kisi);
        return;
      }
      const yon = olay.target.closest('.seri-kutucuk__yon');
      if (!yon) return;
      olay.preventDefault();
      olay.stopPropagation();
      const oge = yon.closest('.seri-kutucuk__oge');
      const sayi = oge?.querySelector('.seri-kutucuk__sayi');
      const kutu = oge?.querySelector('.seri-kutucuk__giris');
      if (!sayi) return;
      const n = parseInt(sayi.value, 10) || 1;
      sayi.value = String(yon.dataset.yon === '+' ? Math.min(20, n + 1) : Math.max(1, n - 1));
      if (kutu && !kutu.checked) kutu.checked = true;
      this.#tazele();
    });
    this.addEventListener('input', (olay) => {
      if (olay.target.matches('.seri-kutucuk__sayi')) this.#tazele();
    });
    // Tema quantity kutusu degisince kutu TAZELENMIYORDU: musteri adedi elle
    // artirinca ozet ve tutar eski kaliyordu (olculdu 19.09.2026: adet 3'te ozet
    // hala "11 parca - set tutari 1.450,00 TL" diyordu). Musteri kendi degistirdiyse
    // teklifin adet yonetimi de birakilir, adedi ona teslim ederiz.
    document.addEventListener('change', (olay) => {
      const t = olay.target;
      if (!(t instanceof HTMLElement) || !t.matches('[name="quantity"]')) return;
      if (this.#adetYaziyor) return;
      this.#anaAdetBiz = false;
      this.#tazele();
    });
    this.ekleEl?.addEventListener('click', () => this.#panelEkle());
    this.#tazele();
    this.#setBilesimKur();

    try {
      const { StandardEvents } = await import('@shopify/events');
      document.addEventListener(StandardEvents.cartLinesUpdate, (olay) => this.#urunEklendi(olay));
    } catch (hata) {
      console.warn('[seri-kutucuk] olay modulu yok, dugme dinleyicisine dusuluyor', hata);
      this.#yedekDinleyici();
    }
  }

  #ac() {
    if (!this.panel || !this.tetik) return;
    const acik = this.tetik.getAttribute('aria-expanded') === 'true';
    this.tetik.setAttribute('aria-expanded', acik ? 'false' : 'true');
    this.panel.hidden = acik;
  }

  get #secili() {
    return this.girisler
      .filter((g) => g.checked)
      .map((g) => {
        const oge = g.closest('.seri-kutucuk__oge');
        const sayi = oge ? oge.querySelector('.seri-kutucuk__sayi') : null;
        const adet = Math.min(20, Math.max(1, parseInt(sayi?.value, 10) || 1));
        return {
          id: Number(g.dataset.variantId),
          fiyat: Number(g.dataset.fiyat || 0) * adet,
          adet,
        };
      })
      .filter((s) => s.id);
  }

  /**
   * Tasarruf seridi: bilesim tamsa "ayri ayri alsan ne oderdin" karsilastirmasi,
   * degilse secilen parcalardaki compare_at indiriminin toplami. Hesap
   * assets/lm-tasarruf.js icinde saf fonksiyon olarak durur (node testi:
   * lamua_set_tasarruf_test.mjs), burada yalniz DOM'dan veri toplanir.
   */
  #tasarrufGoster(secili, tutar, setSatir) {
    const el = this.querySelector('[data-ref="tasarruf"]');
    if (!el) return;
    const satirlar = this.girisler
      .filter((g) => g.checked)
      .map((g) => {
        const oge = g.closest('.seri-kutucuk__oge');
        const sayi = oge ? oge.querySelector('.seri-kutucuk__sayi') : null;
        return {
          fiyat: Number(g.dataset.fiyat || 0),
          eski: Number(g.dataset.eski || 0),
          adet: Math.min(20, Math.max(1, parseInt(sayi?.value, 10) || 1)),
        };
      });
    const sonuc = tasarrufHesapla({
      satirlar,
      // Set sayfasinda ana urun SETIN KENDISI: parca toplamina eklenirse
      // tasarruf sisiyor (olculdu 19.09.2026: Royal 4 kisi %58 yerine %70 yazdi).
      // Tekil sayfada ana urunun ADEDI de sayilir: kirlent sayfasinda set 2 kirlent
      // ister, adet 1 sayilinca taban 2.770 TL cikiyordu (dogrusu 3.100 TL).
      anaFiyat: this.dataset.setSayfasi === '1'
        ? 0
        : Number(this.dataset.anaFiyat || 0) * this.#anaAdetOku(),
      setTutar: setSatir ? tutar : 0,
      tamSet: !!setSatir,
    });
    const kalip =
      sonuc.tur === 'set'
        ? LM('setTasarruf', 'Setle al, [tutar] tasarruf et (%[yuzde]) \u00b7 ayr\u0131 ayr\u0131 [ayri]')
        : LM('setIndirim', 'Bu se\u00e7imde [tutar] indirim var');
    const metin = tasarrufMetni(sonuc, kalip, (k) =>
      formatMoney(k, this.paraBicimi, this.parabirimi)
    );
    el.textContent = metin;
    el.hidden = !metin;
  }

  /**
   * Tekil urun sayfasi teklifi: "N kisilik seti kur, X TL tasarruf". Hesap
   * assets/lm-tasarruf.js -> setTeklifi(). Tiklaninca adetler set bilesimine
   * ayarlanir; kutu zaten var olan tam-bilesim yoluna girer ve sepete SET
   * varyanti gider. Set sayfasinda gosterilmez (orada bilesim zaten hazir).
   */
  /** Tema quantity kutusundaki adet (1-20). Tasarruf tabani bununla carpilir. */
  /** Ana urun adedini secime gore duzeltir. Degistirdiyse true doner (yeni tur kosti). */
  #anaAdetDuzelt() {
    const kutu = document.querySelector('product-form-component [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    if (!(kutu instanceof HTMLInputElement)) return false;
    let bilesimler;
    try { bilesimler = JSON.parse(this.dataset.setBilesim || '{}'); } catch { return false; }
    const kisi = Object.keys(bilesimler).sort((x, y) => Number(x) - Number(y))[0];
    const bilesim = bilesimler[kisi];
    const secim = {};
    this.girisler.forEach((g) => {
      if (!g.checked) return;
      const sayi = g.closest('.seri-kutucuk__oge')?.querySelector('.seri-kutucuk__sayi');
      secim[g.dataset.parca] = Math.max(secim[g.dataset.parca] || 0, parseInt(sayi?.value, 10) || 1);
    });
    const hedef = String(gerekenAnaAdet(bilesim, this.dataset.anaParca || '', secim));
    if (kutu.value === hedef) return false;
    this.#adetYaziyor = true;
    kutu.value = hedef;
    kutu.dispatchEvent(new Event('input', { bubbles: true }));
    kutu.dispatchEvent(new Event('change', { bubbles: true }));
    this.#adetYaziyor = false;
    this.#tazele();
    return true;
  }

  #anaAdetOku() {
    const el = document.querySelector('product-form-component [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    const n = parseInt(el?.value, 10);
    return Number.isFinite(n) && n > 0 ? Math.min(20, n) : 1;
  }

  #teklifGoster(setSatir) {
    const el = this.querySelector('[data-ref="teklif"]');
    if (!el) return;
    if (this.dataset.setSayfasi === '1' || setSatir || !this.dataset.setVaryant) {
      el.hidden = true;
      return;
    }
    try {
      const varyantlar = JSON.parse(this.dataset.setVaryant || '{}');
      const bilesimler = JSON.parse(this.dataset.setBilesim || '{}');
      const kisi = Object.keys(bilesimler).sort((a, b) => Number(a) - Number(b))[0];
      const bilesim = bilesimler[kisi];
      // Ana urunun adedi 1 olmayan sayfada set kurulamaz (#anaSecim adet !== 1 ->
      // null). Orada teklif gosterirsek tutulamayacak fiyat vaat ederiz.
      if (!teklifUygunMu(bilesim, this.dataset.anaParca || '')) { el.hidden = true; return; }
      const setFiyat = Number(varyantlar[kisi]?.fiyat || 0);
      const fiyatlar = {};
      this.girisler.forEach((g) => {
        if (!fiyatlar[g.dataset.parca]) fiyatlar[g.dataset.parca] = Number(g.dataset.fiyat || 0);
      });
      const teklif = setTeklifi({
        bilesim,
        fiyatlar,
        anaParca: this.dataset.anaParca || '',
        anaFiyat: Number(this.dataset.anaFiyat || 0),
        setFiyat,
      });
      if (!teklif) { el.hidden = true; return; }
      const para = (k) => formatMoney(k, this.paraBicimi, this.parabirimi);
      el.textContent = LM('setTeklif', '[kisi] ki\u015filik set [set] \u00b7 tek tek [tekil]')
        .replace('[kisi]', String(kisi))
        .replace('[set]', para(teklif.setFiyat))
        .replace('[tekil]', para(teklif.tekilToplam))
        .replace('[tutar]', para(teklif.tasarruf))
        .replace('[yuzde]', String(teklif.yuzde));
      el.dataset.kisi = String(kisi);
      el.hidden = false;
      // Kapali kutuda da gorunsun: ozet satiri secim yokken bu metni yazar.
      // Yoksa tesvik panelin icinde kaliyor ve musteri kutuyu acmadan gormuyor.
      this.bosMetin = el.textContent;
    } catch {
      el.hidden = true;
    }
  }

  /** Teklif dugmesi: adetleri set bilesimine ayarlar. */
  #teklifUygula(kisi) {
    let bilesim;
    try { bilesim = JSON.parse(this.dataset.setBilesim || '{}')[kisi]; } catch { return; }
    if (!bilesim) return;
    // Ana urunun kendi adedi de bilesime ayarlanir: kirlent sayfasinda set 2
    // kirlent ister, tema kutusu 1'de kalirsa bilesim tamamlanmaz.
    const gerekenAna = anaAdet(bilesim, this.dataset.anaParca || '');
    const anaKutu = document.querySelector('product-form-component [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    if (anaKutu instanceof HTMLInputElement && Number(anaKutu.value || 1) !== gerekenAna) {
      anaKutu.value = String(gerekenAna);
      this.#adetYaziyor = true;
      anaKutu.dispatchEvent(new Event('input', { bubbles: true }));
      anaKutu.dispatchEvent(new Event('change', { bubbles: true }));
      this.#adetYaziyor = false;
      this.#anaAdetBiz = true;
    }
    const gorulen = new Set();
    this.girisler.forEach((g) => {
      const parca = g.dataset.parca;
      const oge = g.closest('.seri-kutucuk__oge');
      const sayi = oge?.querySelector('.seri-kutucuk__sayi');
      if (!sayi) return;
      if (gorulen.has(parca)) { g.checked = false; return; }
      gorulen.add(parca);
      const adet = bilesim[parca] || 0;
      if (adet > 0) { g.checked = true; sayi.value = String(adet); }
      else { g.checked = false; sayi.value = '1'; }
    });
    this.#tazele();
  }

  #tazele() {
    // Teklif ana urunun adedini degistirdiyse, adet secime gore kendini duzeltir.
    // EN BASTA yapilir: adet degisince #anaAdetDuzelt yeni bir tur baslatir, bu tur
    // biter. Yoksa eski (adet degismeden once hesaplanmis) setSatir ile ozet
    // yeniden yazilip yeni turu EZIYORDU -- parca geri takilinca set gelmiyordu
    // (olculdu 19.09.2026: "9 parca secildi - +2.440,00 TL"de takiliyordu).
    if (this.#anaAdetBiz && this.#anaAdetDuzelt()) return;
    const secili = this.#secili;
    let tutar = secili.reduce((t, s) => t + s.fiyat, 0);
    const setSatir = this.#setSatirlari(secili);
    if (setSatir) {
      // sepete set varyanti gidecek: ozette de o fiyat yazsin
      try {
        const v = JSON.parse(this.dataset.setVaryant || '{}');
        // Fiyat, sepete GIDEN satirlarla ayni kaynaktan hesaplanir: setSatirlari
        // kac set + hangi artan parcalar gidecegini zaten cozdu. Ayri hesap
        // tutarsa ekrandaki fiyat sepettekinden sapiyordu.
        // Kisi anahtari variant-picker'dan OKUNMAZ: tekil urun sayfasinda oradaki
        // varyant kisi sayisi degildir. Secilen set varyantinin kimligi aranir.
        const fiyatlar = new Map(this.girisler.map((g) => [Number(g.dataset.variantId), Number(g.dataset.fiyat || 0)]));
        // Ana urun kutuda satir olarak YOK; haritaya eklenmezse set disinda kalan
        // fazla adedi (musteri adedi elle artirirsa) 0 TL sayiliyordu: kirlent
        // sayfasinda adet 3'te ozet 1.450 TL diyordu, dogrusu 1.780 TL
        // (olculdu 19.09.2026).
        const anaForm = document.querySelector('product-form-component, form[action*="/cart/add"]');
        const anaId = Number(anaForm?.querySelector('[name="id"]')?.value || 0);
        if (anaId && !fiyatlar.has(anaId)) fiyatlar.set(anaId, Number(this.dataset.anaFiyat || 0));
        const [setSat, ...artanlar] = setSatir;
        const kayit = Object.values(v).find((x) => Number(x.id) === Number(setSat.id));
        if (kayit?.fiyat) {
          tutar = Number(kayit.fiyat) * setSat.quantity
            + artanlar.reduce((t, f) => t + (fiyatlar.get(f.id) || 0) * f.quantity, 0);
        }
      } catch { /* ozet fiyati parca toplaminda kalir */ }
    }
    this.classList.toggle('seri-kutucuk--secili', secili.length > 0);
    this.#tasarrufGoster(secili, tutar, setSatir);
    this.#teklifGoster(setSatir);
    // Set sayfasi: parca secili degilken tek satin alma yolu temanin kendi
    // dugmesidir (set varyantini ekler). Secim varken gizlenir -> cift alim yok.
    // Tekil urun sayfasinda ayni sey YALNIZ bilesim tamamlaninca gecerli: o an
    // sepete set varyanti gidecegi icin ana urunu tema ayrica eklememeli.
    document.documentElement.classList.toggle(
      'seri-set-hazir',
      this.dataset.setSayfasi === '1' ? secili.length > 0 : !!setSatir
    );
    if (this.ekleEl) this.ekleEl.hidden = secili.length === 0;
    this.#hizliOdemeGizle(secili.length > 0);
    if (!this.ozetEl) return;
    // Bilesim tamamsa tekil sayfada da "set tutari" dili kullanilir: ekranda
    // yazan sayi sepete gidecek SET fiyatidir, parca toplami degil.
    const ozetKalip = setSatir
      ? LM('setOzetSet', '[n] parça · set tutarı [tutar]')
      : this.seciliMetin;
    // Ana urun 1 adet sayiliyordu; kirlent sayfasinda set 2 kirlent istedigi icin
    // ozet "10 parca" diyordu, dogrusu 11 (olculdu 19.09.2026).
    const ozetAdet = secili.reduce((t, s) => t + s.adet, 0)
      + (setSatir && this.dataset.anaParca ? this.#anaAdetOku() : 0);
    this.ozetEl.textContent = secili.length
      ? ozetKalip
          .replace('[n]', String(ozetAdet))
          .replace('[tutar]', formatMoney(tutar, this.paraBicimi, this.parabirimi))
      : this.bosMetin;
    this.#tamSetUyarisi(secili, tutar, setSatir);
    this.#anaFiyatiGuncelle(secili.length ? tutar : null, secili.length > 0 && !setSatir);
    this.#dugmeMetni(setSatir);
    this.#birimFiyatlari(setSatir);
  }

  /**
   * Ustteki buyuk fiyat kutudaki secime gore guncellenir (bildirildi 05.09.2026:
   * "parca ekleyip cikarinca ustteki fiyat degismiyor, iki ayri sayi cikiyor").
   * Secim bosalinca sayfa acilisindaki fiyata doner; varyant degisince onbellek
   * dusurulur cunku fiyati o an tema yeniden yazar.
   */
  #anaFiyatiGuncelle(tutar, bayat) {
    if (this.dataset.setSayfasi !== '1') return;
    const el = document.querySelector('product-price [ref="priceContainer"] .price');
    if (!el) return;
    if (this.#ilkFiyat === null) this.#ilkFiyat = el.textContent;
    el.textContent =
      tutar === null ? this.#ilkFiyat : formatMoney(tutar, this.paraBicimi, this.parabirimi);
    // Kazanc rozeti ("545,00 TL indirim") set varyantinin compare_at'ine gore
    // yazilir. Tam set seciliyken ustteki fiyat da set varyantinin fiyatidir,
    // yani rozet DOGRU -> gorunur kalir. Yalniz bilesim bozulunca (kalanlar
    // tekil fiyattan hesaplanir) bayatlar; o zaman gizlenir.
    // Duzeltildi 10.09.2026: onceki hal `tutar !== null` diye gizliyordu ve
    // kutu varsayilan olarak tam set secili acildigi icin rozet sayfa acilisinda
    // HIC gorunmuyordu (Lima set sayfasinda yakalandi).
    const rozet = document.querySelector('product-price [ref="priceContainer"] .lm-kazanc');
    if (rozet) rozet.hidden = bayat === true;
  }

  /**
   * Tam set seciliyken satirlarda TEKIL fiyat yaziyordu; toplamlari set
   * fiyatindan yuksek oldugu icin musteri "birim fiyatlar tutmuyor" goruyordu.
   * Tam set aktifken her satir set fiyatina oranla olceklenir, tekil fiyat
   * ustu cizili kalir. Yuvarlama farki adedi 1 olan satira (runner) yazilir,
   * boylece olceklenmis fiyatlarin toplami set fiyatina BIREBIR esittir.
   * Bilesim bozulunca gercek tekil fiyatlar geri gelir - sepete o zaman zaten
   * tekil urunler gidiyor.
   */
  #birimFiyatlari(setSatir) {
    if (this.dataset.setSayfasi !== '1') return;
    const kutular = this.girisler.map((g) => g.closest('.seri-kutucuk__oge'));
    kutular.forEach((oge) => {
      if (!oge) return;
      const el = oge.querySelector('.seri-kutucuk__fiyat');
      if (el && el.dataset.ilk === undefined) el.dataset.ilk = el.innerHTML;
    });
    const geriAl = () => kutular.forEach((oge) => {
      const el = oge?.querySelector('.seri-kutucuk__fiyat');
      if (el && el.dataset.ilk !== undefined) el.innerHTML = el.dataset.ilk;
    });
    if (!setSatir) { geriAl(); return; }
    try {
      const k = this.#kisi();
      const setFiyat = Number(JSON.parse(this.dataset.setVaryant || '{}')[k]?.fiyat || 0);
      const bilesim = JSON.parse(this.dataset.setBilesim || '{}')[k] || {};
      if (!setFiyat || !Object.keys(bilesim).length) { geriAl(); return; }
      const satirlar = [];
      this.girisler.forEach((g, i) => {
        const gereken = bilesim[g.dataset.parca] || 0;
        if (!g.checked || !gereken) return;
        satirlar.push({ oge: kutular[i], fiyat: Number(g.dataset.fiyat || 0), gereken, parca: g.dataset.parca });
      });
      const parcaToplam = satirlar.reduce((t, r) => t + r.fiyat * r.gereken, 0);
      if (!parcaToplam || satirlar.length !== Object.keys(bilesim).length) { geriAl(); return; }
      // Set icinde runner sabit fiyatla gosterilir (16.10.2026): lamineli cut
      // runner 320 TL, normal runner 200 TL. Kalan set tutari diger parcalara
      // liste fiyatina oranla dagilir; yuvarlama farki en az adetli parcaya.
      satirlar.forEach((r) => {
        if (r.parca !== 'runner') return;
        const ad = r.oge?.querySelector('.seri-kutucuk__ad')?.textContent || '';
        r.sabit = /lamine/i.test(ad) ? 32000 : 20000;
      });
      const sabitToplam = satirlar.reduce((t, r) => t + (r.sabit || 0) * r.gereken, 0);
      const digerler = satirlar.filter((r) => !r.sabit);
      const digerToplam = digerler.reduce((t, r) => t + r.fiyat * r.gereken, 0);
      if (!digerler.length || !digerToplam || sabitToplam >= setFiyat) satirlar.forEach((r) => { delete r.sabit; });
      const dagit = satirlar.filter((r) => !r.sabit);
      const dagitToplam = dagit.reduce((t, r) => t + r.fiyat * r.gereken, 0);
      const kalan = setFiyat - satirlar.reduce((t, r) => t + (r.sabit || 0) * r.gereken, 0);
      const oran = kalan / dagitToplam;
      satirlar.forEach((r) => { r.yeni = r.sabit || Math.round(r.fiyat * oran); });
      const fark = setFiyat - satirlar.reduce((t, r) => t + r.yeni * r.gereken, 0);
      const tekAdet = dagit.reduce((m, r) => (r.gereken < m.gereken ? r : m), dagit[0]);
      tekAdet.yeni += Math.round(fark / tekAdet.gereken);
      satirlar.forEach((r) => {
        const el = r.oge?.querySelector('.seri-kutucuk__fiyat');
        if (!el || r.yeni <= 0) return;
        el.innerHTML =
          formatMoney(r.yeni, this.paraBicimi, this.parabirimi) +
          '<s class="seri-kutucuk__eski">' +
          formatMoney(r.fiyat, this.paraBicimi, this.parabirimi) + '</s>';
      });
    } catch { geriAl(); }
  }

  /**
   * Tam bilesim seciliyken dugme "Sepete ekle" der; parca cikarilmissa
   * "Secilenleri sepete ekle". Musteri iki ayri satin alma yolu sanmasin.
   */
  #dugmeMetni(setSatir) {
    if (!this.ekleMetinEl || this.#eklemeSuruyor) return;
    // Onceden burada erken cikiliyordu: set kurulup sonra bozulunca dugme
    // "Sepete ekle" metninde kaliyordu (olculdu 19.09.2026).
    if (this.dataset.setSayfasi !== '1' && !setSatir && !this.girisler.some((g) => g.checked)) return;
    this.ekleMetin = setSatir ? LM('sepeteEkle', 'Sepete ekle') : LM('setEkle', 'Seçilenleri sepete ekle');
    this.ekleMetinEl.textContent = this.ekleMetin;
  }

  /**
   * Set fiyati paket indirimlidir; bilesimden parca cikarinca kalanlar tekil
   * fiyattan hesaplanir ve toplam tam setten YUKSEK cikabilir. O zaman soyle.
   */
  #tamSetUyarisi(secili, tutar, setSatir) {
    if (this.dataset.setSayfasi !== '1' || !this.notEl) return;
    if (setSatir || !secili.length) return;
    try {
      const k = this.#kisi();
      const setFiyat = Number(JSON.parse(this.dataset.setVaryant || '{}')[k]?.fiyat || 0);
      if (setFiyat && tutar > setFiyat) {
        this.notEl.textContent =
          'Tam set ' + formatMoney(setFiyat, this.paraBicimi, this.parabirimi) +
          LM('setUyari', ' — bir parça çıkarınca set indirimi düşer, kalanlar tekil fiyattan hesaplanır.');
      }
    } catch { /* uyari yoksa ozet yine dogru */ }
  }

  /**
   * "Hemen satin al" (dinamik odeme) dugmesi sepetten GECMEDIGI icin secilen
   * parcalari tasimaz. Secim varken o dugmeyi gizleyip yerine uyari yaziyoruz;
   * secim kalkinca geri geliyor.
   */
  #hizliOdemeGizle(gizle) {
    const hedefler = document.querySelectorAll(
      '.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"], .shopify-payment-button__button'
    );
    hedefler.forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (gizle) {
        if (!el.dataset.seriGizli) {
          el.dataset.seriGizli = el.style.display || 'yok';
          el.style.display = 'none';
        }
      } else if (el.dataset.seriGizli) {
        el.style.display = el.dataset.seriGizli === 'yok' ? '' : el.dataset.seriGizli;
        delete el.dataset.seriGizli;
      }
    });
    if (this.notEl && hedefler.length) {
      this.notEl.textContent = gizle
        ? (this.dataset.setSayfasi === '1'
            ? LM('setIpucuSet', 'Setin parçaları yukarıdaki “Seçilenleri sepete ekle” ile birlikte sepete gider. Adetleri değiştirebilir, istemediğin parçanın işaretini kaldırabilirsin.')
            : LM('setIpucuTek', 'Seçtiklerin “Sepete ekle”ye bastığında birlikte eklenir. Seçim varken “Hemen satın al” gizlenir, çünkü o adım sepetten geçmez.'))
        : this.#notVarsayilan;
    }
  }

  /** Panel icindeki dugme: ana urunu beklemeden yalniz secilenleri ekler. */
  async #panelEkle() {
    if (this.#eklemeSuruyor || !this.#secili.length) return;
    this.#eklemeSuruyor = true;
    if (this.ekleMetinEl) this.ekleMetinEl.textContent = 'Ekleniyor…';
    try {
      await this.#ekle();
    } finally {
      if (this.ekleMetinEl) this.ekleMetinEl.textContent = this.ekleMetin;
      this.#eklemeSuruyor = false;
    }
  }

  /** Temanin sepete ekleme olayi: ana urun eklendikten sonra secilenleri ekle. */
  async #urunEklendi(olay) {
    if (this.dataset.setSayfasi === '1') return; // set sayfasinda tema dugmesi yok
    if (this.#eklemeSuruyor) return;
    if (olay?.action !== 'add') return;
    if (olay?.target === this || this.contains(olay?.target)) return;
    if (!this.#secili.length) return;

    this.#eklemeSuruyor = true;
    try {
      // Ana urunun eklenmesi bitsin (cart yenilenmis olsun)
      if (olay.promise?.then) {
        await olay.promise.catch(() => null);
      } else {
        await new Promise((c) => setTimeout(c, 700));
      }
      await this.#ekle();
    } finally {
      this.#eklemeSuruyor = false;
    }
  }

  /** Olay modulu yoksa: form dugmesine tiklandiginda kisa gecikmeyle ekle. */
  #yedekDinleyici() {
    if (this.dataset.setSayfasi === '1') return;
    const form = this.closest('product-form-component') || document;
    form.addEventListener('click', (olay) => {
      const hedef = olay.target instanceof Element ? olay.target.closest('button, [type="submit"]') : null;
      if (!hedef || this.contains(hedef)) return;
      if (!/sepete|cart|ekle/i.test(hedef.textContent || '')) return;
      if (!this.#secili.length || this.#eklemeSuruyor) return;
      this.#eklemeSuruyor = true;
      setTimeout(async () => {
        try {
          await this.#ekle();
        } finally {
          this.#eklemeSuruyor = false;
        }
      }, 1200);
    });
  }

  /**
   * Set sayfasi: secim tam set bilesimiyse sepete SET VARYANTI gider (sayfada
   * yazan ve Google feed'ine giden fiyat budur). Bilesimin uzerindeki adetler
   * fark kadar ayri parca satiri olur. Bilesimden az secilirse parca fiyati.
   */
  /**
   * Tekil urun sayfasinda ana urunun kendisi de set bileseninin bir parcasidir
   * (runner sayfasinda runner). Kutuda listelenmedigi icin formdan okunur.
   * Adet 1 degilse set mantigi devreye girmez - kat hesabi ana urunde belirsiz kalir.
   */
  #anaSecim() {
    const parca = this.dataset.anaParca;
    if (!parca) return null;
    const form = document.querySelector('product-form-component, form[action*="/cart/add"]');
    const id = Number(form?.querySelector('[name="id"]')?.value || 0);
    const adet = Number(form?.querySelector('[name="quantity"]')?.value || 1) || 1;
    // 19.09.2026: onceden `adet !== 1` iken null donuyordu; bu yuzden bilesimde
    // 2+ adet gecen parcalarin sayfasinda (kirlent 2, servis 4, altlik 4) set
    // ASLA kurulamiyordu. Adet artik oldugu gibi donuyor; kac tam set ciktigini
    // zaten #kat() adet/gereken oranindan hesapliyor, fazlasi tekil satir olarak
    // sepete gidiyor.
    if (!id) return null;
    return { parca, id, adet };
  }

  /** Adet haritasi bilesime uyuyorsa kac tam set cikar; uymuyorsa null. */
  #kat(bilesim, adetler) {
    let kat = Infinity;
    for (const [parca, gereken] of Object.entries(bilesim)) {
      const secim = adetler.get(parca);
      if (!secim || secim.adet < gereken) return null;
      if (gereken > 0) kat = Math.min(kat, Math.floor(secim.adet / gereken));
    }
    if (!Number.isFinite(kat) || kat < 1) return null;
    for (const parca of adetler.keys()) if (!(parca in bilesim)) return null;
    return kat;
  }

  #setSatirlari(secili) {
    const setSayfasi = this.dataset.setSayfasi === '1';
    const ana = setSayfasi ? null : this.#anaSecim();
    if (!setSayfasi && !ana) return null;
    let bilesim, varyant;
    try {
      bilesim = JSON.parse(this.dataset.setBilesim || '{}');
      varyant = JSON.parse(this.dataset.setVaryant || '{}');
    } catch { return null; }
    const adetler = new Map();
    this.girisler.forEach((g) => {
      if (!g.checked) return;
      const sayi = g.closest('.seri-kutucuk__oge')?.querySelector('.seri-kutucuk__sayi');
      adetler.set(g.dataset.parca, { id: Number(g.dataset.variantId), adet: Math.max(1, parseInt(sayi?.value, 10) || 1) });
    });
    if (ana) adetler.set(ana.parca, { id: ana.id, adet: ana.adet, ana: true });

    let kisi = null;
    if (setSayfasi) {
      kisi = this.#kisi();
    } else {
      // Tekil sayfada kisi sayisi secilmez; adetler birden fazla bilesime uyabilir.
      // ILK uyani almak yanlis: servis6+altlik6+kirlent2 hem "4 kisilik + 2 fazla
      // servis + 2 fazla altlik" (2.490 TL) hem "6 kisilik" (1.795 TL) okunur.
      // Musteri lehine EN UCUZ okuma secilir.
      const fiyatlar = new Map(this.girisler.map((g) => [g.dataset.parca, Number(g.dataset.fiyat || 0)]));
      let enIyi = null;
      for (const k of Object.keys(bilesim)) {
        if (!varyant[k]?.id) continue;
        const k2 = this.#kat(bilesim[k], adetler);
        if (k2 === null) continue;
        let toplam = Number(varyant[k].fiyat) * k2;
        for (const [parca, gereken] of Object.entries(bilesim[k])) {
          const artan = adetler.get(parca).adet - gereken * k2;
          if (artan > 0) toplam += artan * (fiyatlar.get(parca) || 0);
        }
        if (!enIyi || toplam < enIyi.toplam) enIyi = { k, toplam };
      }
      kisi = enIyi ? enIyi.k : null;
    }
    const i = kisi && bilesim[kisi];
    const v = kisi && varyant[kisi];
    if (!i || !v?.id) return null;
    // Kac TAM set cikiyor: her parcada adet/gereken taban degerinin en kucugu.
    // Onceden set hep quantity 1 gidiyordu, bilesimin ustundeki her adet
    // INDIRIMSIZ tekil parca sayiliyordu; 2 set isteyen 4.760 TL goruyordu
    // (dogrusu 3.120 TL, Rio 4 kisilik, olculdu 16.09.2026).
    const kat = this.#kat(i, adetler);
    if (kat === null) return null;
    const fazlalar = [];
    for (const [parca, gereken] of Object.entries(i)) {
      const secim = adetler.get(parca);
      const artan = secim.adet - gereken * kat;
      if (artan > 0) fazlalar.push({ id: secim.id, quantity: artan });
    }
    return [{ id: Number(v.id), quantity: kat }, ...fazlalar];
  }

  async #ekle() {
    const secili = this.#secili;
    if (!secili.length) return;
    const items = this.#setSatirlari(secili) || secili.map((s) => ({ id: s.id, quantity: s.adet }));
    const bolumler = [...document.querySelectorAll('cart-items-component')]
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
      .filter(Boolean);

    let olayModulu = null;
    let ertelenen = null;
    try {
      olayModulu = await import('@shopify/events');
      ertelenen = olayModulu.CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(
        new olayModulu.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
          promise: ertelenen.promise,
        })
      );
    } catch {
      /* olaysiz da eklemeye devam */
    }

    try {
      const url = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const yanit = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: bolumler.join(',') }),
      });
      const veri = await yanit.json();
      if (!yanit.ok || veri.status) throw new Error(veri.description || veri.message || 'Eklenemedi');

      const sepetUrl = window.Theme?.routes?.cart_url || '/cart';
      const sepet = await fetch(`${sepetUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

      ertelenen?.resolve?.({
        cart: olayModulu.CartLinesUpdateEvent.createCartFromAjaxResponse(sepet),
        detail: {
          items: sepet.items,
          source: 'seri-kutucuk',
          sourceId: this.id || 'seri-kutucuk',
          itemCount: items.length,
          sections: veri.sections,
          didError: false,
        },
      });

      if (this.dataset.setSayfasi === '1') {
        // Secim korunur: kutucuklar bosalirsa tema dugmesi geri gelir ve
        // musteri ayni sunumu bir de SET varyanti olarak alabilir.
        if (this.ozetEl) this.ozetEl.textContent = 'Set sepete eklendi';
        return;
      }
      this.girisler.forEach((g) => {
        g.checked = false;
      });
      this.#tazele();
    } catch (hata) {
      console.error('[seri-kutucuk]', hata);
      ertelenen?.reject?.(hata);
      if (this.ozetEl) this.ozetEl.textContent = LM('setHata', 'Parçalar eklenemedi, tekrar deneyin');
    }
  }
}

if (!customElements.get('seri-kutucuk')) {
  customElements.define('seri-kutucuk', SeriKutucuk);
}
